function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23 26.08V10.243c0-.306-.104-.51-.31-.715L12.067.23a.815.815 0 00-1.135 0L.31 9.528c-.206.204-.309.409-.309.715V26.08c0 .511.413.92.928.92H7.22a.92.92 0 00.929-.92v-6.948c0-.511.412-.92.825-.92h5.054c.413 0 .825.409.825.92v6.948c0 .511.413.92.929.92h6.29a.92.92 0 00.929-.92z"
});

var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "#ADAFB3"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/home-icon.caafdb71.svg";
export { SvgHomeIcon as ReactComponent };